import React from "react"
import { BAND_EMAIL, SOCIAL_LINKS, STREAMING_LINKS } from "../links"
import "./Contact.css"

const SHARE_LINKS = [
    { name: "Share on Facebook", icon: "fab fa-facebook-f", href: "https://www.facebook.com/sharer/sharer.php?u=lowfye50.com" },
    { name: "Share on Twitter", icon: "fab fa-twitter", href: "https://twitter.com/intent/tweet?text=lowfye50.com" },
    { name: "Share by email", icon: "fas fa-envelope", href: "mailto:?subject=Lowfye50&body=Check%20out%20this%20band%20at%20%3A%20lowfye50.com" },
]

const IconLinks = ({ links }) => (
    <div className="lf-footer__icons">
        {links.map(link => (
            <a key={link.name} target="_blank" rel="noreferrer" href={link.href} aria-label={link.name} title={link.name}>
                <i className={link.icon}></i>
            </a>
        ))}
    </div>
)

export const Contact = () => (
    <footer className="lf-footer">
        <div className="lf-wrap">
            <div className="lf-footer__grid">
                <div>
                    <h5>{"// BOOKING & PRESS"}</h5>
                    <div className="lf-footer__big">
                        Let's make<br />some noise.<br />
                        <a href={`mailto:${BAND_EMAIL}?subject=Interested%20in%20Lowfye50`}>{BAND_EMAIL}</a>
                    </div>
                </div>

                <div>
                    <h5>{"// FOLLOW"}</h5>
                    <IconLinks links={[...SOCIAL_LINKS, ...STREAMING_LINKS]} />
                </div>

                <div>
                    <h5>{"// SHARE #LOWFYE50"}</h5>
                    <IconLinks links={SHARE_LINKS} />
                </div>
            </div>

            <div className="lf-footer__giant" aria-hidden="true">LOWFYE50</div>

            <div className="lf-footer__legal">
                <span>© {new Date().getFullYear()} LOWFYE50</span>
                <span>NASHVILLE, TENNESSEE</span>
            </div>
        </div>
    </footer>
)
